import React, { useState, useEffect, useRef } from "react";
import OSILayerColumn from "./OSILayerColumn";
import BuildUpPacket from "./BuildUpPacket";
import PopupDetails from "./PopupDetails";
import osiData from "../data/osiData";
import "../App.css";

const OSIVisualization = () => {
  const [highlightedLayer, setHighlightedLayer] = useState(null);
  const [selectedLayer, setSelectedLayer] = useState(null);
  const [isAnimating, setIsAnimating] = useState(false);
  const [packetLogs, setPacketLogs] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [speed, setSpeed] = useState(1000);
  const logRef = useRef(null);

  useEffect(() => {
    if (logRef.current) {
      logRef.current.scrollTop = logRef.current.scrollHeight;
    }
  }, [packetLogs]);

  const startAnimation = (direction) => {
    if (isAnimating) return;
    setIsAnimating(true);
  
    // 방향에 따라 계층 순서를 결정
    const layers = direction === "sender" ? osiData : [...osiData].reverse();
  
    layers.forEach((layer, index) => {
      setTimeout(() => {
        setHighlightedLayer(layer.key);
  
        // 이전 계층이 존재하는 경우 로그 형식 변경
        if (index > 0) {
          const prevLayer = layers[index - 1];
          setPacketLogs((prevLogs) => [
            `[${direction === "sender" ? "전송" : "수신"}] ${prevLayer.name} → ${layer.name}`,
            ...prevLogs,
          ]);
        }
  
        if (index === layers.length - 1) {
          setTimeout(() => {
            setHighlightedLayer(null);
            setIsAnimating(false);
          }, speed);
        }
      }, index * speed);
    });
  };  

  const clearLogs = () => {
    setPacketLogs([]);
  };

  const handleLayerClick = (layerKey) => {
    const layer = osiData.find((l) => l.key === layerKey);
    setSelectedLayer(layer || null);
  };

  const filteredLogs = packetLogs.filter((log) =>
    log.toLowerCase().includes(searchKeyword.toLowerCase())
  );

  return (
    <div className="osi-visualization">
      <div className="osi-left">
        <OSILayerColumn
          title="계층 구조"
          layers={osiData}
          highlightedLayer={highlightedLayer}
          onHighlight={setHighlightedLayer}
          onClick={handleLayerClick}
        />
        <hr className="divider" />
        <div className="buttons">
          <button className="send-button" onClick={() => startAnimation("sender")}>
            전송 시작
          </button>
          <button className="receive-button" onClick={() => startAnimation("receiver")}>
            수신 시작
          </button>
          <input
            type="range"
            min="500"
            max="3000"
            step="100"
            value={speed}
            onChange={(e) => setSpeed(e.target.value)}
          />
        </div>
      </div>
      
      <hr className="vertical-divider" />
      
      <div className="osi-center">
        <BuildUpPacket highlightedLayer={highlightedLayer} />
      </div>
      
      <hr className="vertical-divider" />
      
      <div className="osi-right" ref={logRef}>
        <div className="log-header">
          <h3>패킷 이동 로그</h3>
          <input
            type="text"
            className="log-search"
            placeholder="로그 검색..."
            value={searchKeyword}
            onChange={(e) => setSearchKeyword(e.target.value)}
          />
          <button className="clear-log-button" onClick={clearLogs}>
            로그 초기화
          </button>
        </div>
        <ul className="log-list">
          {filteredLogs.slice(0, 20).map((log, index) => (
            <li key={index} className={index === 0 ? "highlight-log" : "log-item"}>
              {log}
            </li>
          ))}
        </ul>
      </div>

      {selectedLayer && (
        <PopupDetails layer={selectedLayer} onClose={() => setSelectedLayer(null)} />
      )}
    </div>
  );
};

export default OSIVisualization;
